import React, { useState } from "react";
import { Box } from "@mui/material";
import { toast } from "react-toastify";

import { ActionButton, FormDialog, InputField } from "../v3";
import { AdminService } from "../../services";
import { resetPasswordValidation } from "../../pages/administration/validation";

export const ResetPassword = ({ userId, open, onClose }) => {
  const [passwordData, setPasswordData] = useState({ password: undefined, confirmPassword: undefined });
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };

  const togglePasswordVisibility = (type) => {
    if (type === "password") {
      setShowPassword((prev) => !prev);
    } else {
      setShowConfirmPassword((prev) => !prev);
    }
  };

  const handleResetPassword = async () => {
    setError({});

    const validationErrors = resetPasswordValidation(passwordData);
    if (Object.keys(validationErrors).length > 0) {
      setError(validationErrors);
      return;
    }

    try {
      setLoading(true);
      await AdminService.resetPassword(userId, { password: passwordData.password });
      toast.success("Password reset successfully");
      handleCloseModal();
    } catch (error) {
      console.error("Error resetting password:", error);
      toast.error("Failed to reset password. Please try again");
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setPasswordData({ password: undefined, confirmPassword: undefined });
    setShowPassword(false);
    setError({});
    onClose();
  };

  return (
    <FormDialog
      title="Reset Password"
      open={open}
      onClose={onClose}
      sx={{ width: "500px" }}
      actions={
        <>
          <ActionButton buttonText="Cancel" onButtonClick={handleCloseModal} variant="outlined" />
          <ActionButton buttonText="Save" onButtonClick={handleResetPassword} disabled={loading} />
        </>
      }
    >
      <Box mt={1}>
        <Box display="flex" flexDirection="column">
          <InputField
            required
            name="password"
            fullWidth
            label="password"
            type={showPassword ? "text" : "password"}
            value={passwordData.password}
            togglePasswordVisibility={() => togglePasswordVisibility("password")}
            onChange={handlePasswordChange}
            error={!!error.password}
            helperText={error.password}
          />
          <InputField
            required
            name="confirmPassword"
            fullWidth
            label="confirm password"
            type={showConfirmPassword ? "text" : "password"}
            value={passwordData.confirmPassword}
            togglePasswordVisibility={() => togglePasswordVisibility("confirmPassword")}
            onChange={handlePasswordChange}
            error={!!error.confirmPassword}
            helperText={error.confirmPassword}
          />
        </Box>
      </Box>
    </FormDialog>
  );
};
